module.exports = __webpack_public_path__ + "assets/img/introduction-en.010bfc98.png";